import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  card: (grow: boolean) => ({
    ...(grow ? { flex: 1 } : { flexShrink: 0 }),
    minWidth: '180px',
    borderRadius: '8px',
    p: '16px'
  } satisfies SxProps<Theme>),
  heading: {
    mb: '16px'
  } satisfies SxProps<Theme>,
  // Reserved even when absent so tiles in a row keep a common baseline.
  subtitle: (present: boolean) => ({
    color: 'text.secondary',
    visibility: present ? 'visible' : 'hidden'
  } satisfies SxProps<Theme>),
  panel: (color: string, panel: string) => ({
    display: 'flex',
    alignItems: 'stretch',
    boxSizing: 'border-box',
    borderRadius: '8px',
    overflow: 'hidden',
    height: '130px',
    backgroundColor: panel,
    border: '4px solid',
    borderColor: color,
    borderRightWidth: '32px'
  } satisfies SxProps<Theme>),
  iconWell: (color: string) => ({
    backgroundColor: color,
    color: 'var(--white)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '112px',
    flexShrink: 0
  } satisfies SxProps<Theme>),
  valueWell: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    px: '24px'
  } satisfies SxProps<Theme>,
  value: (color: string) => ({
    color,
    fontSize: '44px',
    lineHeight: 1
  } satisfies SxProps<Theme>)
}
